import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { AppButton, Box, Heading } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import ExcessContributionWithdrawModal from '@/components/modals/ExcessContributionWithdrawModal/ExcessContributionWithdrawModal';
import { useExcessContributionAvailable } from '@/components/modals/ExcessContributionWithdrawModal/useExcessContributionAvailable';
import { useBreadcrumbs } from '@/modules/core/hooks';
import { TaxForms } from '@/modules/investments';
import { useMyEnrollments } from '@/modules/transaction';

const TaxFormsPage = () => {
  const { accountId = '' } = useParams<{ accountId: string }>();
  const { t } = useTranslation();
  const { currentMyAccount } = useMyEnrollments(accountId);

  useBreadcrumbs(
    [
      {
        key: ROUTES.HOME,
        title: t('Home'),
        value: ROUTES.HOME,
      },
      {
        key: ROUTES.MY_ACCOUNTS,
        title: t('My accounts'),
        value: `${ROUTES.MY_ACCOUNTS}`,
      },
      {
        key: ROUTES.MY_ACCOUNTS_DETAILS(accountId),
        title: currentMyAccount?.name,
        value: ROUTES.MY_ACCOUNTS_DETAILS(accountId),
      },
      {
        key: ROUTES.TAX_FORMS(accountId),
        title: t('Tax Forms'),
        value: ROUTES.TAX_FORMS(accountId),
      },
    ],
    true
  );
  const { isExcessContributionAvailable } = useExcessContributionAvailable();
  const [isModalVisible, setModalVisible] = useState(false);
  const { isOpenHSAExist } = useMyEnrollments(accountId);
  return (
    <Box>
      <Box direction="row" align="center" justify="between" data-testid="tax-forms_wrapper">
        <Heading level={1} size="regular" data-testid="tax-forms_header">
          {t('Tax Forms')}
        </Heading>
        {isExcessContributionAvailable && isOpenHSAExist ? (
          <Box margin={{ left: 'spacing24' }}>
            <AppButton
              testId="withdrawExcessContributions"
              width="250px"
              onClick={() => setModalVisible(true)}
              buttonType="secondary"
            >
              Withdraw Excess Contributions
            </AppButton>
          </Box>
        ) : null}
      </Box>
      <TaxForms isStandAloneMode />
      {isModalVisible ? <ExcessContributionWithdrawModal onSetVisible={setModalVisible} isEditMode /> : null}
    </Box>
  );
};
export default TaxFormsPage;
